import React from "react";
import "./App.scss";
import TextBody from "canvas-core-react/lib/TextBody";
import Grid from "canvas-core-react/lib/Grid";
import Row from "canvas-core-react/lib/Row";
import Column from "canvas-core-react/lib/Column";
import AppProvider, {AppContext} from "./context/AppContext";
import {StepsClient} from "./views/Steps-Client";
import LogoScotiaWealthManagement from "./assets/images/logo-header-scotia-wealth-management.svg";
import LogoFlyingS from "canvas-core-react/lib/LogoFlyingS";

const App = () => {
    return (
        <AppProvider>
            <div className="App-Wealth">
                <div className="Header">
                    <Grid>
                        <Row>
                            <Column>
                                <img
                                    className="logo-web"
                                    src={LogoScotiaWealthManagement}
                                    alt="logo-scotia-wealth-management"
                                />
                                <LogoFlyingS id="logo-flying-s" className="logo-mobile"/>
                            </Column>
                        </Row>
                    </Grid>
                </div>
                <main>
                    <AppContext.Consumer>
                        {(context) => (
                            <div>
                                <StepsClient/>
                            </div>
                        )}
                    </AppContext.Consumer>
                </main>
                <div className="Footer">
                    <Grid>
                        <Row>
                            <Column>
                                <TextBody component="span" type="1">
                                    © 2021 Scotiabank. All Rights Reserved.
                                </TextBody>
                            </Column>
                        </Row>
                    </Grid>
                </div>
            </div>
        </AppProvider>
    );
};

export default App;
